export const hexToSignedInt = (hexColor: string): string => {
  // Add FF at the front for full opacity if only RRGGBB is provided
  const argbHex = 'FF' + hexColor?.replace('#', '');
  let argbInt = parseInt(argbHex, 16);

  // Handle two's complement for negative numbers
  if (argbInt > 0x7fffffff) {
    argbInt = argbInt - 0x100000000;
  }

  return String(argbInt);
};

export const signedIntToHex = (signedInt: number | string): string => {
  if (signedInt == null || signedInt === '') return '#000000';

  const rgbValue = parseInt(String(signedInt)) & 0x00ffffff;
  return `#${rgbValue.toString(16).padStart(6, '0')}`;
};

export const colorPairToHex = (colorPairStr: string): string => {
  if (!colorPairStr) return '#000000';

  const [foregroundColor] = colorPairStr.split(',');
  return signedIntToHex(foregroundColor);
};
